import { computed } from "mobx";
import * as moment from "moment";

import { Form, field } from "lib/form";
import { SortDirection } from "lib/enums";

export default class NewsFilter extends Form {
  @field("Preset") public preset: string[];

  @field("검색기간")
  public targetRange: { start: string; end: string };

  @field("Source") public source: number[];

  @field("Category") public tag: number[];

  @field("Order By") public orderBy: string;

  @field("Sort") public sort: SortDirection;

  @computed
  public get startDate() {
    return this.targetRange && this.targetRange.start
      ? moment(this.targetRange.start)
      : undefined;
  }

  @computed
  public get endDate() {
    return this.targetRange && this.targetRange.end
      ? moment(this.targetRange.end)
      : undefined;
  }
}
